import { SimpleGrid, SimpleGridProps } from '@chakra-ui/react'

import { createWidget } from '../widget-utils'

export type RowWidgetProps = SimpleGridProps

/**
 * TODO: We should just name this as grid or simplegrid, but we have
 * a naming collision with AGGrid and the Tables being called Grid.
 */
export const RowWidget = ({
  isLoading,
  ...props
}: RowWidgetProps & { isLoading?: boolean }) => <SimpleGrid {...props} />

export const RowWidgetDefinition = createWidget(RowWidget, { type: 'Row' })
